exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".articlePageContentSub--Header\n{\n    font-weight: 800;\n    padding-top: 1%;\n    text-decoration: none;\n    color: rgb(0,0,0);\n}\n\n#articlePageContentSub--Header1\n{\n    padding-top: 0%;\n}\n\n.articlePageContentSub--Content\n{\n    \n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ppeters/filmCritClient/src/app/components/articleContent/articleContent.component.css
// module id = ../../../../../src/app/components/articleContent/articleContent.component.css
// module chunks = main